import { Trans } from '~/common/context';
import { Alert, Flex, Modal, Text, Title } from '@wyz/ui';
import { IJob } from '~/common/types';
import { useCommonErrorTranslation } from '~/common/hooks';

type Props = {
  job: IJob;
  onClose: () => void;
};

function DetailModal({ job, onClose }: Props) {
  const { resolveErrorKey } = useCommonErrorTranslation();
  return (
    <Modal.Container open={true} onClose={onClose} size='lg'>
      <Modal.Header>
        <Modal.Title>
          <Title weight='bold'>
            <Trans
              i18nKey='app.common.import.job_detail.title'
              values={{
                fileName: job.originalFileName,
              }}
            />
          </Title>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {job.status === 'SUCCEEDED' && (
          <>
            {job.metadata?.data && (
              <>
                <Title weight='bold' className='mb-2'>
                  <Trans i18nKey='app.common.results' />
                </Title>
                {job.metadata.data.createdCount !== undefined && (
                  <Text heading='normal' weight='medium'>
                    <Trans
                      i18nKey='app.common.import.job_detail.created_count'
                      values={{
                        count: job.metadata.data.createdCount,
                      }}
                    />
                  </Text>
                )}
                {job.metadata.data.updatedCount !== undefined && (
                  <Text heading='normal' weight='medium'>
                    <Trans
                      i18nKey='app.common.import.job_detail.updated_count'
                      values={{
                        count: job.metadata.data.updatedCount,
                      }}
                    />
                  </Text>
                )}
                {job.metadata.data.enabledCount !== undefined && (
                  <Text heading='normal' weight='medium'>
                    <Trans
                      i18nKey='app.common.import.job_detail.enabled_count'
                      values={{
                        count: job.metadata.data.enabledCount,
                      }}
                    />
                  </Text>
                )}
                {job.metadata.data.disabledCount !== undefined && (
                  <Text heading='normal' weight='medium'>
                    <Trans
                      i18nKey='app.common.import.job_detail.disabled_count'
                      values={{
                        count: job.metadata.data.disabledCount,
                      }}
                    />
                  </Text>
                )}
              </>
            )}
          </>
        )}
        {job.status === 'FAILED' && (
          <>
            {job.metadata.errors.length === 0 ? (
              <Alert variant='danger'>
                <Trans i18nKey='app.common.import.job_detail.technical_error' />
              </Alert>
            ) : (
              <>
                <Title weight='bold' className='mb-2'>
                  <Trans i18nKey='app.common.import.job_detail.errors' />
                </Title>
                <ul className='text-danger-text'>
                  {job.metadata.errors.map((error, index) => (
                    <li key={index}>
                      <Trans
                        i18nKey={resolveErrorKey(error.message)}
                        values={error.context}
                      />
                    </li>
                  ))}
                </ul>
              </>
            )}
          </>
        )}
        {(job.status === 'QUEUED' || job.status === 'PROCESSING') && (
          <Flex justifyContent='center'>
            <Text heading='normal' weight='medium'>
              <Trans i18nKey='app.common.import.job_detail.processing' />
            </Text>
          </Flex>
        )}
      </Modal.Body>
    </Modal.Container>
  );
}

export default DetailModal;
